module.exports = __webpack_public_path__ + "c768ae643f8e5beda15945d114891968.svg";